/**
 * Unified error class for all CCMS SDK operations
 * Thrown when API calls fail or encounter errors
 */
export class CCMSError extends Error {
    constructor(params) {
        super(params.message);
        this.name = 'CCMSError';
        this.code = params.code;
        this.status = params.status;
        this.timestamp = new Date().toISOString();
        this.errors = params.errors;
        this.correlationId = params.correlationId;
        this.raw = params.raw;
        // Maintains proper stack trace for where our error was thrown (only available on V8)
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, CCMSError);
        }
    }
}
//# sourceMappingURL=CCMSError.js.map